import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-设备",
  "use": "icon-设备-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-设备\"><path d=\"M638.15 609.9125h-93.478125v93.31875h93.478125v-93.31875z m163.48125 0h-93.4875v93.31875h93.4875v-93.31875zM782.95625 194.84375H241.053125L91.53125 512v317.15625h840.9375V512L782.95625 194.84375z m84.103125 573.69375H156.95V540.0125h710.109375v228.525z\" p-id=\"17122\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol